import './ErrorPage.css';
import { NebulaButton as d } from "@discoveryedu/nebula-components";
import { resolveComponent as u, openBlock as r, createElementBlock as n, createElementVNode as o, toDisplayString as t, createCommentVNode as a, renderSlot as i, createVNode as m, createTextVNode as h, Fragment as y, renderList as b } from "vue";
import { _ as g } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
const p = {
  name: "ErrorPage",
  components: {
    NebulaButton: d
  },
  props: {
    headline: {
      type: String
    },
    message: {
      type: String
    },
    error: {
      type: String
    },
    helpUrl: {
      type: String
    },
    problemIdent: {
      type: String
    },
    requestId: {
      type: String
    },
    htmlDisplayMessage: {
      type: String
    },
    extraInformationDict: {
      type: Object
    }
  }
}, f = { class: "nebula-error" }, I = { class: "nebula-error__content" }, k = { class: "nebula-error__type" }, D = { class: "nebula-error__heading" }, S = { class: "nebula-error__message" }, N = { key: 0 }, v = { class: "nebula-error__help" }, q = ["href"], B = {
  key: 1,
  class: "nebula-error__error-codes"
}, E = { key: 0 }, M = { key: 1 }, H = ["innerHTML"], V = {
  key: 3,
  class: "nebula-error__extra-info"
}, C = /* @__PURE__ */ o("div", { class: "nebula-error__spaceman" }, null, -1);
function L(s, P, e, T, x, U) {
  const _ = u("NebulaButton");
  return r(), n("div", f, [
    o("div", I, [
      o("h3", k, t(e.error), 1),
      o("h1", D, t(e.headline), 1),
      o("div", S, [
        e.message ? (r(), n("p", N, t(e.message), 1)) : a("", !0),
        i(s.$slots, "content"),
        i(s.$slots, "buttons", {}, () => [
          m(_, {
            link: "/",
            class: "nebula-error__home-link",
            size: "m",
            text: s.$t("Go to the DE Home")
          }, null, 8, ["text"])
        ]),
        o("p", v, [
          h(t(s.$t("Need Help?")) + " ", 1),
          o("a", { href: e.helpUrl }, t(s.$t("Contact Support")), 9, q)
        ]),
        e.problemIdent || e.requestId ? (r(), n("p", B, [
          o("span", null, t(s.$t("If you require assistance, please include these codes when asking for help:")), 1),
          e.problemIdent ? (r(), n("span", E, t(s.$t("Problem ID:")) + " " + t(e.problemIdent), 1)) : a("", !0),
          e.requestId ? (r(), n("span", M, t(s.$t("Request ID:")) + " " + t(e.requestId), 1)) : a("", !0)
        ])) : a("", !0),
        e.htmlDisplayMessage ? (r(), n("div", {
          key: 2,
          innerHTML: e.htmlDisplayMessage,
          class: "nebula-error__html-display-message"
        }, null, 8, H)) : a("", !0),
        e.extraInformationDict ? (r(), n("div", V, [
          (r(!0), n(y, null, b(e.extraInformationDict, (c, l) => (r(), n("p", { key: l }, t(l) + ": " + t(c), 1))), 128))
        ])) : a("", !0)
      ])
    ]),
    C
  ]);
}
const F = /* @__PURE__ */ g(p, [["render", L]]);
export {
  F as default
};
